import { render, staticRenderFns } from "./FactoryVisual.vue?vue&type=template&id=e4908778"
import script from "./FactoryVisual.vue?vue&type=script&lang=js"
export * from "./FactoryVisual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports